var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.364 15.364L9 21.728L2.636 15.364C1.37734 14.1054 0.520187 12.5017 0.172928 10.7559C-0.17433 9.01007 0.00390685 7.20047 0.685099 5.55595C1.36629 3.91142 2.51984 2.50582 3.99988 1.51689C5.47992 0.52796 7.21998 0.00012207 9 0.00012207C10.78 0.00012207 12.5201 0.52796 14.0001 1.51689C15.4802 2.50582 16.6337 3.91142 17.3149 5.55595C17.9961 7.20047 18.1743 9.01007 17.8271 10.7559C17.4798 12.5017 16.6227 14.1054 15.364 15.364ZM9 11C9.53044 11 10.0391 10.7893 10.4142 10.4143C10.7893 10.0392 11 9.53048 11 9.00004C11 8.46961 10.7893 7.9609 10.4142 7.58583C10.0391 7.21076 9.53044 7.00004 9 7.00004C8.46957 7.00004 7.96086 7.21076 7.58579 7.58583C7.21072 7.9609 7 8.46961 7 9.00004C7 9.53048 7.21072 10.0392 7.58579 10.4143C7.96086 10.7893 8.46957 11 9 11Z",
    fill: "url(#paint0_linear_293_4624)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_293_4624",
    x1: 9,
    y1: -0.736418,
    x2: 9,
    y2: 27.6434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CD889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007846"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationGreen);
export default __webpack_public_path__ + "static/media/location-green.f70af6599402044df4c782053b5ac6f2.svg";
export { ForwardRef as ReactComponent };